import { render, staticRenderFns } from "./addtask.vue?vue&type=template&id=34d497bc&scoped=true"
import script from "./addtask.vue?vue&type=script&lang=js"
export * from "./addtask.vue?vue&type=script&lang=js"
import style0 from "./addtask.vue?vue&type=style&index=0&id=34d497bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d497bc",
  null
  
)

export default component.exports